import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Building2 } from 'lucide-react';

const PlatformTenants = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/platform/tenants')
      .then((response) => setTenants(response.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="platform-tenants">
      <div>
        <h1 className="text-4xl font-bold tracking-tight">Tenants</h1>
        <p className="mt-2 text-muted-foreground">Empresas e operações cadastradas na plataforma</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Building2 className="h-5 w-5" /> Tenants cadastrados</CardTitle>
          <CardDescription>{loading ? 'Carregando...' : `${tenants.length} tenant(s)`}</CardDescription>
        </CardHeader>
        <CardContent>
          {!loading && tenants.length === 0 ? (
            <p className="py-8 text-center text-muted-foreground">Nenhum tenant cadastrado.</p>
          ) : (
            <div className="space-y-3">
              {tenants.map((tenant) => (
                <div key={tenant.id} className="flex items-center justify-between rounded-lg border p-4">
                  <div>
                    <div className="flex items-center gap-3">
                      <p className="font-medium">{tenant.name}</p>
                      <Badge variant={tenant.status === 'Active' ? 'default' : 'secondary'}>{tenant.status}</Badge>
                    </div>
                    <p className="mt-1 text-sm text-muted-foreground">Tenant #{tenant.tenant_number} · {tenant.document}</p>
                  </div>
                  <p className="text-xs text-muted-foreground">{tenant.id}</p>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PlatformTenants;
